"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CornerDialog", {
  enumerable: true,
  get: function get() {
    return _CornerDialog.default;
  }
});

var _CornerDialog = _interopRequireDefault(require("./src/CornerDialog"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb3JuZXItZGlhbG9nL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IGFzIENvcm5lckRpYWxvZyB9IGZyb20gJy4vc3JjL0Nvcm5lckRpYWxvZydcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/corner-dialog/index.js
// module id = 154
// module chunks = 0